<!-- <template>
  <v-card-text>
    <v-data-table
      v-model="selected"
      item-key="id"
      :height="`${winHeight - 200}px`"
      single-select
      :items="items"
      :headers="headers"
      class="elevation-1"
      disable-pagination
      hide-default-footer
      hide-default-header
      :key="key"
      dense
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      show-expand
      :show-select="$vuetify.breakpoint.smAndUp"
      :single-select="true"
    >
      <template v-slot:[`item.body`]="{ item }">
        <span style="font-weight: 900; color: black">
          {{ item.createdByFullName ? item.createdByFullName : '  نا مشخص ' }}
        </span>

        <span class="mr-1">{{
          item.body.length > 25 ? item.body.slice(0, 25) + '...' : item.body
        }}</span>

        <v-badge
          v-if="item.unreadThreadCount > 0"
          color="success"
          :content="item.unreadThreadCount"
        >
        </v-badge>
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <v-card class="mr-2 mx-auto" color="blue-grey lighten-4">
            <v-card-title>
              <span style="font-weight: 600; color: blue">موضوع :</span>
              <span style="font-weight: 900">
                {{ item.category.topicDisplayName }}
              </span>
              <v-btn text color="primary" @click="goToPage(item)"> مشاهده</v-btn>
            </v-card-title>

            <v-card-text class="text-right border">
              <span style="font-weight: 600; color: blue">متن پیام</span>
              <span style="font-weight: 900"> {{ item.body }}</span>
            </v-card-text>
            <v-card-actions>
              <v-btn
                text
                block
                color="primary"
                @click="rowClick(item), selectRow(item)"
              >
                مشاهده گفتگو
              </v-btn>
            </v-card-actions>
          </v-card>
        </td>
      </template>
    </v-data-table>
  </v-card-text>
</template> -->
<template>
  <v-card class="mx-auto" max-width="500">
    <v-toolbar color="blue lighten-2" dark height="90">


      <v-toolbar-title class="text-wrap font-weight-black  black--text mt-5">پیامهای شما 
         <p style="font-weight: 500;">کلیه پیامهای ادمین و سایر مخاطبان شما در خصوص محصولات و خدمات شما در اینجا مشاهده  می‌شود</p>  
      </v-toolbar-title>
       
    </v-toolbar>

    <v-virtual-scroll :items="items" :item-height="70" height="600">
      <template v-slot:default="{ item }">
        <v-list-item
          :class="item.id == selectedId ? 'blue lighten-4' : ''"
          @click="selectedItem(item.id), rowClick(item)"
        >
          <template v-slot:default="{ active }">
            <v-list-item-avatar>
              <img
                v-if="item.profilePicture"
                class="symbol-label"
                :src="item.profilePicture"
                alt=""
              />
              <v-icon v-else class="grey lighten-1" dark> mdi-account </v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>
                <v-icon small color="blue">mdi-message</v-icon> {{ item.body }}
              </v-list-item-title>

              <v-list-item-subtitle
                class="font-weight-black"
                v-text="item.createdByFullName"
              ></v-list-item-subtitle>
              <v-list-item-subtitle
                class="text--primary"
                v-text="'موضوع :' + item.category.topicDisplayName"
              ></v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <v-list-item-action-text
                class="text-right"
                v-text="item.relativeTime"
              ></v-list-item-action-text>
              <v-list-item-action-text>
                <v-btn depressed small @click="goToPage(item)">
                  موضوع
                  <v-icon color="orange darken-4" right>
                    mdi-open-in-new
                  </v-icon>
                </v-btn>
              </v-list-item-action-text>
            </v-list-item-action>
          </template>
        </v-list-item>
      </template>
    </v-virtual-scroll>

    <!-- <v-list two-line>
      <v-list-item-group v-model="selected" active-class="blue--text">
        <template v-for="(item, index) in items">
          <v-list-item :key="item.id">
            <template v-slot:default="{ active }">
              <v-list-item-avatar>
                <img
                  v-if="item.profilePicture"
                  class="symbol-label"
                  :src="item.profilePicture"
                  alt=""
                />
                <v-icon v-else class="grey lighten-1" dark>
                  mdi-account
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-text="item.body"></v-list-item-title>

                <v-list-item-subtitle
                  class="text--primary"
                  v-text="item.headline"
                ></v-list-item-subtitle>

                <v-list-item-subtitle
                  v-text="item.createdByFullName"
                ></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-list-item-action-text @click="rowClick(item), selectRow(item)">
                 
                    مشاهده گفتگو
                  
                </v-list-item-action-text>

                <v-list-item-action-text
                  v-text="item.relativeTime"
                ></v-list-item-action-text>
                <v-list-item-action-text>
                  <v-badge
                    v-if="item.unreadThreadCount > 0"
                    color="success"
                    :content="item.unreadThreadCount"
                  >
                  </v-badge>
                </v-list-item-action-text>

                <v-icon v-if="!active" color="grey lighten-1">
                  mdi-star-outline
                </v-icon>

                <v-icon v-else color="yellow darken-3"> mdi-star </v-icon>
              </v-list-item-action>
            </template>
          </v-list-item>

          <v-divider v-if="index < items.length - 1" :key="index"></v-divider>
        </template>
      </v-list-item-group>
    </v-list>
     -->
  </v-card>
</template>
<script>
import { RepoFactory } from '@/baseRepository/Factory';
const conversationRepository = () => RepoFactory.get('conversation');
import Helper from '@/core/helpers';
import ThreadsList from './ThreadsList.vue';

export default {
  data() {
    return {
      selected: [],
      selectedId: '',
      expanded: [],
      singleExpand: true,
      winHeight: 0,
      key: 0,
      showThread: false,
      selectedConversation: null,
      items: [],
      pageNumber: 1,
      itemsPerPage: 1000,
      pageCount: 0,
      headers: [
        { text: '', value: 'data-table-expand' },
        {
          value: 'body',
          text: 'متن',
          sortable: false,
          width: '70%',
        },
        {
          value: 'relativeTime',
          text: 'زمان',
          sortable: false,
          width: '20%',
        },

        // {
        //   value: 'operation',
        //   text: 'مشاهده موضوع',
        //   sortable: false,
        //   width: 15,
        // },
      ],
      mobileHeaders: [],
    };
  },
  created() {
    if (this.currentMerchant != null) {
      this.getData();
    }
  },
  mounted() {
    this.winHeight = window.innerHeight;
  },
  computed: {
    baseUrl() {
      return this.$store.getters.contentBaseUrl;
    },
    currentMerchant() {
      return this.$store.getters.currentMerchant;
    },
  },
  watch: {
    currentMerchant() {
      this.getData();
    },
    pageNumber() {
      this.getData();
    },
    itemsPerPage() {
      this.getData();
    },
  },
  methods: {
    selectedItem(id) {
      this.selectedId = id;
    },
    selectRow(item) {
      this.selected = [];
      this.selected.push(item);
    },
    rowClick(item) {
      // item.unreadThreadCount = 0;
      //row.select(true);
      this.$emit('getSelectedConversation', item);
      let val = this.$vuetify.breakpoint.smAndDown ? false : true;
      this.$store.commit('setShowThread', true);
      this.$store.commit('setShowConv', val);
      this.$store.commit('setFullName', item.createdByFullName);
    },
    getData() {
      let app = this;
      this.items = [];
      let params = {
        PageNumber: this.pageNumber,
        ItemsPerPage: this.itemsPerPage,
        MerchantId: this.$store.getters.currentMerchant
          ? this.$store.getters.currentMerchant
          : null,
      };
      const loader = this.$loading.show();
      conversationRepository()
        .getConversationList(
          app.baseUrl,
          { MerchantId: this.$store.getters.currentMerchant },
          params
        )
        .then((res) => {
          this.key += 1;
          if (res.data.list != null) {
            this.items = res.data.list;
            this.pageCount = Math.ceil(res.data.totalCount / this.itemsPerPage);
          } else {
            this.items = [];
            this.pageCount = 1;
          }
          app.loadingPagesTable = false;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => loader.hide());
    },
    showThreads(item) {
      this.selectedConversation = item;
      this.showThread = true;
    },
    goToPage(item) {
      if (item.category.categoryUriDtos.length > 0) {
        var objectId = item.objectId;
        console.log('item.category.categoryUriDtos');
        console.log(item.category.categoryUriDtos);
        var findedItem = item.category.categoryUriDtos.find(
          (e) => e.uriType == 'Merchant'
        );
        if (findedItem) {
          console.log('findedItem');
          console.log(findedItem);
          //categoryId ==5 SupplierProduct
          var path = findedItem.urlScheme.replace('{0}', objectId);
          this.$router.push({
            path: path,
          });
        }
      }
    },
  },
  components: {
    ThreadsList,
  },
};
</script>

<style lang="scss" scoped>
tr.v-data-table__selected {
  background: #91a3ff !important;
}
</style>
